import React from "react";
import { Form, AutoComplete, Tooltip } from "antd";
import { get } from 'lodash';

const AutoCompleteInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  disabled,
  callback,
  size,
  tooltip,
  items
}) => (
  <Form.Item label={tooltip ? <Tooltip placement='right' title={tooltip}>{label}</Tooltip> : label} {...formItemLayout}
    hasFeedback={!!get(errors, name)}
    validateStatus={get(errors, name) && "error"}
    help={get(errors, name)}
  >
    <AutoComplete
      dataSource={items}
      size={size}
      placeholder={placeholder}
      value={get(values, name)}
      onChange={(value) => {
        setFieldValue(name, value);
      }}
      onBlur={() => {
        setFieldTouched(name);
        if (callback) {
          callback();
        }
      }}
      onSelect={(value) => {
        setFieldValue(name, value);
      }}
      //onPressEnter={handleSubmit}
      readOnly={readOnly} disabled={disabled}
    />
  </Form.Item>
);

export default AutoCompleteInput;
